import {
    ENABLE_CHECKOUT_CORE_RESILIENCY_TLZ,
    RESILIENCE_TLZ_ACTIONS,
} from '../constants/splitio';
import { CheckoutState } from '../state';
import { getTlzEnv } from '../utils/bff';
import { getIsProd } from './app';
import { getEventId } from './event';
import { getIsMultiValueTargetingRulesAttributeEnabled } from './splitioMultiValueTargetingRules';

export const getBffRequestBaseParams = (state: CheckoutState) => ({
    eventId: getEventId(state),
    env: getTlzEnv(getIsProd(state)),
});

export const getBffResilienceActionUrl = (
    state: CheckoutState,
    actionName: string,
) => {
    const isResiliencyActionEnabled =
        getIsMultiValueTargetingRulesAttributeEnabled(
            state,
            ENABLE_CHECKOUT_CORE_RESILIENCY_TLZ,
            actionName,
        );

    const resilienceActionHandler = isResiliencyActionEnabled
        ? RESILIENCE_TLZ_ACTIONS[actionName]
        : undefined;

    if (!resilienceActionHandler) {
        return undefined;
    }

    return resilienceActionHandler(state);
};
